<style>
  .app-body { margin-top: 0px; background-color: #334155 !important;}
  .main {
  background-color: #334155 !important;
}
</style>
<fq-maintenance-banner [isTop]="true"></fq-maintenance-banner>
@if (viewAzure() || viewlogin() || viewforgot() || viewexpired()) {
  <div [class.awp]="projectName == 'AWP-UI'" class="app-body mt-0">
    <main class="main flex min-h-screen items-center justify-center px-4 py-8">
      <div class="w-full max-w-md">
        <div class="fuseqCard smooth overflow-hidden rounded-2xl border border-gray-100 bg-fq-surface p-6 shadow-[0_1px_2px_rgba(16,24,40,0.05),0_14px_40px_-12px_rgba(16,24,40,0.22)]">

          @if (viewlogin()) {
            <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
              <div class="mb-5 flex flex-nowrap items-center justify-center gap-4">
                @if (demoMode == false) {
                  <img [src]="'../../../assets/img/brand/'+projectLogo"  class="logo1 h-[30px] invert-[65%]"  />
                }
                @if (demoMode == false) {
                  <img [src]="'../../../assets/img/brand/'+customerLogo"  class="logo2 h-[30px]"/>
                }
              </div>

              <div class="mb-2 text-center text-base font-bold text-slate-100">Login</div>

              @if (browserSupported) {
                @if (showISEAlarm) {
                  <div class="callout callout-danger mb-4">
                    <small class="text-slate-300">Errore durante autenticazione ISE</small>
                    <br>
                    <strong class="text-sm font-semibold text-slate-100">L'utente non è associato ad un profilo ISE</strong>
                  </div>
                }

                <div class="relative mt-2">
                  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                    <fa-icon [icon]="['fas', 'user']"></fa-icon>
                  </span>
                  <input type="text" formControlName="userName"
                    class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30"
                    [ngClass]="{ 'border-fq-danger': submitted && f.userName.errors }"
                    placeholder="Username" autocomplete="verifyuserName">
                </div>
                @if (submitted && f.userName.errors && f.userName.errors.required) {
                  <span class="fq-field-error block">Username obbligatorio</span>
                }

                <div class="relative mt-3">
                  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                    <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                  </span>
                  <input type="password" formControlName="password"
                    class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30"
                    [ngClass]="{ 'border-fq-danger': submitted && f.password.errors }"
                    placeholder="Password" autocomplete="verifycurrent-password">
                </div>
                @if (submitted && f.password.errors && f.password.errors.required) {
                  <span class="fq-field-error block">Password obbligatoria</span>
                }
                @if (submitted && f.password.errors && f.password.errors.minlength) {
                  <span class="fq-field-error block">Password troppo corta</span>
                }

                <div class="mt-5">
                  <button [disabled]="loading()" type="submit"
                    class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-fq-primary px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-primary/90 disabled:cursor-not-allowed disabled:opacity-60">
                    @if (loading()) {
                      <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
                    }
                    Login
                  </button>
                </div>
              }
              @if (!browserSupported) {
                <h4 class="font-semibold text-fq-danger">Browser in uso non supportato</h4>
              }
            </form>
            <div class="mt-3 text-center">
              <button type="button"
                class="rounded-md px-3.5 py-1.5 text-sm font-semibold text-fq-primary transition hover:bg-fq-primary/10"
                (click)="usernamereset = null;viewlogin.set(false); viewforgot.set(true); sendRequestReset.set(true); isDisable.set(true)">Forgot Password</button>
            </div>
          }

          @if (viewforgot()) {
            <div class="mb-5 flex flex-nowrap items-center justify-center gap-4">
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+projectLogo"  class="logo1 h-[30px] invert-[65%]"  />
              }
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+customerLogo"  class="logo2 h-[30px]"/>
              }
            </div>

            <div class="mb-2 text-center text-base font-bold text-slate-100">Forgot Password</div>

            @if (browserSupported) {
              <div class="relative mt-2">
                <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                  <fa-icon [icon]="['fas', 'user']"></fa-icon>
                </span>
                <input type="text" placeholder="Username" [(ngModel)]="usernamereset" (keyup)="checkuser('forgot')"
                  class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
              </div>

              @if (!sendRequestReset()) {
                <div class="relative mt-3">
                  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                    <fa-icon [icon]="['fas', 'key']"></fa-icon>
                  </span>
                  <input type="text" placeholder="Token" [(ngModel)]="verificationToken" (keyup)="checkToken()"
                    class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
                </div>
              }

              @if (!sendRequestReset()) {
                <div class="relative mt-3">
                  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                    <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                  </span>
                  <input type="password" placeholder="New Password" [(ngModel)]="newPassword" (keyup)="confirmpassword('forgot')"
                    class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30"
                    pTooltip="At least 10 characters. One special character. One uppercase letter. One lowercase letter. One number. No username." tooltipPosition="top" appendTo="body">
                </div>
              }

              @if (!sendRequestReset()) {
                <div class="relative mt-3">
                  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                    <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                  </span>
                  <input type="password" placeholder="Confirm Password" [(ngModel)]="cpassword" (keyup)="confirmpassword('forgot')"
                    class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
                </div>
              }

              <div class="mt-2 text-center">
                <h6 [hidden]="!isDisable()">
                  <span class="inline-block rounded-full bg-fq-danger px-3 py-1 text-xs font-semibold text-white">{{PasswordMessage()}}</span>
                </h6>
              </div>

              <div class="mt-4 flex items-center gap-3">
                @if (sendRequestReset()) {
                  <button type="button" [disabled]="usernamereset == null" (click)="requestReset(usernamereset)"
                    class="inline-flex flex-1 items-center justify-center rounded-lg bg-fq-primary px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-primary/90 disabled:cursor-not-allowed disabled:opacity-60">
                    Reset Password
                  </button>
                  <button type="button" (click)="resetformforgot()"
                    class="inline-flex flex-1 items-center justify-center rounded-lg bg-fq-danger px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-danger/90">
                    Cancel
                  </button>
                }
                @if (!sendRequestReset()) {
                  <button type="button" [disabled]="isDisable()" (click)="resetPassword()"
                    class="inline-flex w-full items-center justify-center rounded-lg bg-fq-primary px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-primary/90 disabled:cursor-not-allowed disabled:opacity-60">
                    Change Password
                  </button>
                }
              </div>
            }
            @if (!browserSupported) {
              <h4 class="font-semibold text-fq-danger">Browser in uso non supportato</h4>
            }
          }

          @if (viewexpired()) {
            <div class="mb-5 flex flex-nowrap items-center justify-center gap-4">
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+projectLogo"  class="logo1 h-[30px] invert-[65%]"  />
              }
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+customerLogo"  class="logo2 h-[30px]"/>
              }
            </div>

            <div class="mb-2 text-center text-base font-bold text-slate-100">Change Password</div>

            @if (browserSupported) {
              <div class="relative mt-2">
                <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                  <fa-icon [icon]="['fas', 'user']"></fa-icon>
                </span>
                <input type="text" placeholder="Username" [(ngModel)]="usernamereset" (keyup)="checkuser('reset')"
                  class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
              </div>

              <div class="relative mt-3">
                <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                  <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                </span>
                <input type="password" placeholder="Old Password" [(ngModel)]="oldPassword" (keyup)="checkoldpassword()"
                  class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
              </div>

              <div class="relative mt-3">
                <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                  <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                </span>
                <input type="password" placeholder="New Password" [(ngModel)]="newPassword" (keyup)="confirmpassword('reset')"
                  class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30"
                  pTooltip="At least 10 characters. One special character. One uppercase letter. One lowercase letter. One number. No username." tooltipPosition="top" appendTo="body">
              </div>

              <div class="relative mt-3">
                <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-300">
                  <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                </span>
                <input type="password" placeholder="Confirm Password" [(ngModel)]="cpassword" (keyup)="confirmpassword('reset')"
                  class="w-full rounded-lg border border-white/20 bg-black/25 py-2 pl-10 pr-3 text-sm text-slate-100 placeholder-slate-400 outline-none transition focus:border-fq-primary focus:ring-2 focus:ring-fq-primary/30">
              </div>

              <div class="mt-2 text-center">
                <h6 [hidden]="!isDisable()">
                  <span class="inline-block rounded-full bg-fq-danger px-3 py-1 text-xs font-semibold text-white">{{PasswordMessage()}}</span>
                </h6>
              </div>

              <div class="mt-4 flex items-center gap-3">
                <button type="button" [disabled]="isDisable()" (click)="changePassword()"
                  class="inline-flex flex-1 items-center justify-center rounded-lg bg-fq-primary px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-primary/90 disabled:cursor-not-allowed disabled:opacity-60">
                  Change Password
                </button>
                <button type="button" (click)="resetformexpired()"
                  class="inline-flex items-center justify-center rounded-lg bg-fq-danger px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-danger/90">
                  Cancel
                </button>
              </div>
            }
            @if (!browserSupported) {
              <h4 class="font-semibold text-fq-danger">Browser in uso non supportato</h4>
            }
          }

          @if (viewAzure()) {
            <div class="mb-5 flex flex-nowrap items-center justify-center gap-4">
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+projectLogo"  class="logo1 h-[30px] invert-[65%]"  />
              }
              @if (demoMode == false) {
                <img [src]="'../../../assets/img/brand/'+customerLogo"  class="logo2 h-[30px]"/>
              }
            </div>

            @if (browserSupported) {
              <div class="mt-3">
                <button [disabled]="loading()" (click)="azureLogin()"
                  class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-fq-primary px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-fq-primary/90 disabled:cursor-not-allowed disabled:opacity-60">
                  @if (loading()) {
                    <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
                  }
                  MFA Login
                </button>
              </div>
            }
            @if (!browserSupported) {
              <h4 class="font-semibold text-fq-danger">Browser in uso non supportato</h4>
            }
          }

        </div>
      </div>
    </main>
  </div>
}
